import React, { useMemo } from "react";
import { RouteGuard } from "./RouteGuard";

interface OnboardingRouteProps {
  children: React.ReactNode;
}

/**
 * Route protection for onboarding pages
 * Only allows access if user is a new user (is_new_user === true)
 * Redirects to /home if user is not a new user
 */
export const OnboardingRoute: React.FC<OnboardingRouteProps> = ({ children }) => {
  // Memoize config to prevent unnecessary re-renders
  const config = useMemo(() => ({
    requireAuth: true,
    requireNewUser: true,
    redirectTo: "/home",
    redirectMessage: "Redirecting...",
  }), []);

  return (
    <RouteGuard config={config}>
      {children}
    </RouteGuard>
  );
};

